import { Outlet } from 'react-router-dom';
import React from 'react';
import Navbar from '../adminComponents/Navbar';
import SiteFooter from '../adminComponents/SiteFooter';
import SessionValidator from '../auth/SessionValidator';
import { Box, Grid } from '@chakra-ui/react';

function DefaultLayout() {
    return (
        <Box textAlign="center" fontSize="l">
            <Grid minH="100vh">
                <Navbar />
                <SessionValidator />
                <Outlet />
                <SiteFooter />
            </Grid>
        </Box>
    );
};

export default DefaultLayout;
